import React, { useContext } from 'react';
import { Copy, Optional } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';

import formatSelectedProductLinesText from './utility/formatSelectedProductLinesText';
import themeStyles from './ProductLineDisclaimer.style';
import { DealersListContext } from '../DealersListContext';

const DealerDisclaimer = themeStyles.apply(Copy, 'DealerFilterDisclaimer');

const ProductLineDisclaimerText = () => {
  const { productLinesSelection } = useContext(DealersListContext);
  const { t } = useTranslation();

  const productLines = formatSelectedProductLinesText(productLinesSelection, t);
  const disclaimerContent = t('Sub-apps.Dealers.disclaimerText', { productLines });

  return (
    <Optional when={disclaimerContent}>
      <DealerDisclaimer data-testid="cy-dealer-discalimer">{disclaimerContent}</DealerDisclaimer>
    </Optional>
  );
};

export default ProductLineDisclaimerText;
